import React from "react";
import { StyleProp, ViewStyle, View, Text, StyleSheet } from "react-native";
import { colors } from "../common/styles/colors";
import { fonts } from "../common/styles/fonts";
import { CheckTrue } from "../common/icons/CheckTrue";
import { CheckFalse } from "../common/icons/CheckFalse";
import { CommonButton } from "./buttons";
import { MascotSubscribeStarter } from "../common/icons/mascot_subscribe_starter";
import { MascotSubscribeMedium } from "../common/icons/mascot_subscribe_medium";
import { MascotSubscribePremium } from "../common/icons/mascot_subscribe_premium";

export type FeatureType = {
  available: boolean;
  name: string;
};

export type SubscriptionType = {
  id: number;
  title: string;
  type: "start" | "medium" | "premium";
  price: string;
  features: Array<FeatureType>;
};

export function SubscriptionCard({
  subscription,
  containerStyle,
  onSubscribe,
  buttonText = "Buy now!",
  isActive = false,
  validUntill,
}: {
  subscription: SubscriptionType;
  containerStyle?: StyleProp<ViewStyle>;
  onSubscribe?: () => void;
  buttonText?: string;
  isActive?: boolean;
  validUntill?: string;
}) {
  const icon = {
    start: <MascotSubscribeStarter width={95} />,
    medium: <MascotSubscribeMedium width={95} />,
    premium: <MascotSubscribePremium width={95} />,
  };
  return (
    <View style={[styles.cardContainer, containerStyle]}>
      <Text
        style={[
          fonts.averageLargeText_bold,
          { color: colors.black, marginBottom: 16 },
        ]}
      >
        {subscription.title}
      </Text>
      <View style={styles.priceContainer}>
        {icon[subscription.type]}
        <View style={{ flexDirection: "row", alignItems: "flex-end" }}>
          <Text style={[fonts.huge_normal, { color: colors.black }]}>
            {subscription.price}
          </Text>
          <Text
            style={[fonts.mediumLargeText_regular, { color: colors.black }]}
          >
            {" "}
            /month
          </Text>
        </View>
      </View>
      <View style={styles.line} />
      <Text style={[fonts.mediumText_bold, styles.description]}>
        What’s inside?
      </Text>
      <View
        style={{
          alignItems: "flex-start",
          marginBottom: 16,
        }}
      >
        {subscription.features.map((feature) => (
          <View style={{ flexDirection: "row", marginBottom: 12 }}>
            <View style={{ width: 24, marginRight: 8 }}>
              {feature.available ? <CheckTrue /> : <CheckFalse />}
            </View>
            <Text
              style={[
                fonts.mediumText_regular,
                { color: feature.available ? colors.noteGray : colors.gray50 },
              ]}
            >
              {feature.name}
            </Text>
          </View>
        ))}
      </View>
      <CommonButton
        textStyle={fonts.mediumText_bold}
        title={buttonText}
        type="blackFilled"
        containerStyle={{ minWidth: 200 }}
        onPress={onSubscribe}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  cardContainer: {
    paddingHorizontal: 36,
    paddingVertical: 24,
    flexDirection: "column",
    alignItems: "center",
    borderRadius: 16,
    boxShadow: "0px 4px 12px 0px rgba(92, 107, 140, 0.30)",
    maxWidth: 375,
    width: "100%",
    marginBottom: 12,
  },
  priceContainer: {
    flexDirection: "row",
    marginBottom: 16,
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    maxWidth: 240,
  },
  line: {
    borderBottomWidth: 1,
    borderBottomColor: colors.gray81,
    width: "100%",
    marginBottom: 16,
  },
  description: {
    color: colors.black,
    marginBottom: 12,
    textAlign: "left",
    alignSelf: "flex-start",
    fontWeight: "600",
  },
});
